import { render, staticRenderFns } from "./CustomFormTypesField.vue?vue&type=template&id=f2e6a346"
import script from "./CustomFormTypesField.vue?vue&type=script&lang=ts"
export * from "./CustomFormTypesField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports